<template>
  <RouterView v-if="router.currentRoute.value.name" />
  <main v-else class="session-check" role="status" aria-live="polite">
    <span class="session-check__spinner" aria-hidden="true" />
    <span>Cargando…</span>
  </main>
</template>

<script setup lang="ts">
import { useRouter } from 'vue-router'

const router = useRouter()
</script>

<style>
.session-check {
  min-height: 100vh;
  display: grid;
  place-items: center;
  gap: 0.75rem;
  background: var(--p-surface-50, #f8fafc);
  color: var(--p-text-muted-color, #64748b);
  font-family: system-ui, sans-serif;
  font-size: 0.9rem;
}

.session-check__spinner {
  display: block;
  width: 2rem;
  height: 2rem;
  border: 3px solid var(--p-primary-200, #bfdbfe);
  border-top-color: var(--p-primary-500, #3b82f6);
  border-radius: 50%;
  animation: spin 0.8s linear infinite;
}

@keyframes spin {
  to { transform: rotate(360deg); }
}
</style>
